export const tableTransactionVerificationsTitles = [
  'Sent At',
  'Status',
  'Phone',
  'carrier Name',
];
